import About from '../pages/About';
import Decks from '../pages/Decks';
import Definition from '../pages/Definition';
import Home from '../pages/Home';
import ForgotPassword from '../pages/ForgotPassword';
import Login from '../pages/Login';
import Mission from '../pages/Mission';
import Feedback from '../pages/Feedback';
import RegisterUser from '../pages/RegisterUser';
import Resources from '../pages/Resources';
import ResetPassword from '../pages/ResetPassword';
import WordOfTheDay from '../pages/WordOfTheDay';
import UserAccount from '../pages/UserAccount';
import UserConfirmed from '../pages/UserConfirmed';
import UserVerified from '../pages/UserVerified';

import { Router, Route, IndexRoute } from 'inferno-router';
import createBrowserHistory from 'history/createBrowserHistory';

const browserHistory = createBrowserHistory();

const routes = store => (
  <Router history={browserHistory}>
    <Route>
      <IndexRoute component={Home} />
      <Route path="/about" component={About} />
      <Route path="/account" component={UserAccount} />
      <Route path="/confirm" component={UserConfirmed} />
      <Route path="/verify" component={UserVerified} />
      <Route path="/definition" component={Definition}>
        <Route path="/definition/:wordId" component={Definition} />
      </Route>
      <Route path="/flashcards" component={Decks} />
      <Route path="/forgot-password" component={ForgotPassword} />
      <Route path="/login" component={Login} />
      <Route path="/mission" component={Mission} />
      <Route path="/feedback" component={Feedback} />
      <Route path="/register" component={RegisterUser} />
      <Route path="/reset-password" component={ResetPassword} />
      <Route path="/resources" component={Resources} />
      <Route path="/word-of-the-day" component={WordOfTheDay} />
    </Route>
  </Router>
);

export default routes;



// WEBPACK FOOTER //
// ./src/routes/routes.js